'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetBotResponder = undefined;

var _reselect = require('reselect');

var _getBotResponder = require('conversations-schema/operators/widget-data/getBotResponder');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var getWidgetBotResponder = exports.getWidgetBotResponder = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], _getBotResponder.getBotResponder);